// extracted by mini-css-extract-plugin
module.exports = {"horizontal_span":"horizontal-span_horizontal_span__KZq9G"};